import { styled } from '../../system';
export const Prose = styled('div', {
    maxW: 720,
    textLg: true,
    color: '$textMuted',
    fontFamily: '$sans',
    '& p': {
        my: '$4'
    },
    '& b, & strong': {
        fontWeight: '$medium'
    },
    '& [class~="lead"]': {
        textXl: true,
        my: '$5'
    },
    '& blockquote': {
        m: 0,
        my: '$12',
        pl: '$5',
        py: '$2',
        textXl: true,
        fontWeight: '$medium',
        fontStyle: 'italic',
        bl: '2px solid $primary700',
        color: '$text'
    },
    '& blockquote > *:first-of-type': {
        mt: 0
    },
    '& blockquote > *:last-of-type': {
        mb: 0
    },
    '& h1': {
        textDisplayXs: true,
        fontWeight: '$medium',
        mt: 0,
        mb: '$6',
        color: '$text'
    },
    '& h2': {
        textXl: true,
        fontWeight: '$medium',
        mt: '$12',
        mb: '$6',
        color: '$text'
    },
    '& h3': {
        textLg: true,
        fontWeight: '$medium',
        mt: '$12',
        mb: '$6',
        color: '$text'
    },
    '& h4': {
        textMd: true,
        fontWeight: '$medium',
        mt: '$12',
        mb: '$6',
        color: '$text'
    },
    '& img': {
        mt: '$4',
        mb: '$4'
    },
    '& video': {
        mt: '$4',
        mb: '$4'
    },
    '& figure': {
        p: 0,
        m: 0,
        mt: '$4',
        mb: '$4'
    },
    '& figure > *': {
        mt: 0,
        mb: 0
    },
    '& figcaption': {
        textSm: true,
        mt: '$3dot5'
    },
    '& code': {
        textSm: true
    },
    '& pre': {
        textSm: true,
        my: '$3dot5',
        p: '$3dot5',
        rounded: '$base',
        color: '$neutral200',
        bgColor: '$neutral900',
        overflowX: 'auto'
    },
    '& ol, & ul': {
        py: '$4',
        pl: '$5'
    },
    '& li': {
        my: '$4',
        pl: '$4'
    },
    '& ol > li, & ul > li': {
        pl: '$4'
    },
    '& > ul > li p': {
        my: '$4'
    },
    '& > ul > li > *:first-child': {
        mt: '$4'
    },
    '& > ul > li > *:last-child': {
        mb: '$4'
    },
    '& > ol > li > *:first-child': {
        mt: '$4'
    },
    '& > ol > li > *:last-child': {
        mb: '$4'
    },
    '& ul ul, & ul ol, & ol ul, & ol ol': {
        my: 0,
        py: 0
    },
    '& ol': {
        listStyleType: 'none',
        counterReset: 'item',
        pl: 0
    },
    '& ol > li': {
        pl: 0,
        display: 'table',
        counterIncrement: 'item',
        '&::before': {
            content: 'counter(item) "."',
            display: 'table-cell',
            paddingRight: '0.6em'
        }
    },
    '& li ol > li:before': {
        content: 'counters(item, ".") " "'
    },
    '& hr': {
        w: '$full',
        d: 'block',
        my: '$12',
        b: 'none',
        bt: '1px solid $neutral200',
        h: 0
    },
    '& hr + *': {
        mt: 0
    },
    '& h2 + *': {
        mt: 0
    },
    '& h3 + *': {
        mt: 0
    },
    '& h4 + *': {
        mt: 0
    },
    '& table': {
        w: '$full',
        textMd: true,
        borderCollapse: 'collapse',
        my: '$12'
    },
    '& thead': {
        bb: '2px solid $borderColor'
    },
    '& tr': {
        bb: '1px solid $borderColor'
    },
    '& thead th': {
        mx: '$3dot5',
        pb: '$3dot5',
        p: '$3dot5',
        textAlign: 'left'
    },
    '& thead th:first-child': {
        pl: 0
    },
    '& thead th:last-child': {
        pr: 0
    },
    '& tbody td, tfoot td': {
        p: '$3dot5'
    },
    '& tbody td:first-child, tfoot td:first-child': {
        pl: 0
    },
    '& tbody td:last-child, tfoot td:last-child': {
        pr: 0
    },
    '@xs': {
        textLg: true,
        '& h1': {
            textDisplayMd: true
        },
        '& h2': {
            textDisplayXs: true
        },
        '& h3': {
            textXl: true
        },
        '& h4': {
            textLg: true
        }
    }
});
Prose.displayName = 'Prose';
